import { useState } from "react"

export const useSteps = (names) => {
  /*
  [
    {name: tag, value: null},
    {name: tamano, value: null},
  ]  
  */

  const iniState = names.map((step) => ({
    name: step,
    value: null,
  }))

  const [state, setState] = useState(iniState)

  const steps = {
    get currentIx() {
      return state.findIndex((step) => step.value == null)
    },

    get current() {
      return state[steps.currentIx]
    },

    get len() {
      return state.length
    },

    get done() {
      return steps.currentIx === -1
    },

    at: (x) => steps.currentIx > -1 && steps.current.name === x,

    setAt: (ix, x) => {
      let newState = [...state]
      newState[ix].value = x
      setState(newState)
    },

    setCurrent: (x) => {
      let ix = steps.currentIx
      if (ix === -1) return
      steps.setAt(ix, x)
    },

    setter: (name) => (x) => {
      let stepIx = state.findIndex((step) => step.name === name)
      if (stepIx === -1) return
      steps.setAt(stepIx, x)
    },

    goTo: (ix) => {
      let head = state.slice(0, ix),
        tail = state.slice(ix).map((x) => ({ ...x, value: null }))
      setState(head.concat(tail))
    },

    get data() {
      return Object.fromEntries(state.map((step) => [step.name, step.value]))
    },
  }

  return [steps]
}
